import { useCallback, useMemo } from 'react';
import { clearAccessTokens } from '@ecp/common/src/utils/utils';
import { useNavigate } from 'react-router-dom';
import { PAGE_ID } from '@ecp/common/src/const/redirectConst';
import * as Netfunnel from '@ecp/common/src/utils/netfunnel.d.ts';
// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import { SITE_KOREANAIR_SAVINGS, SITE_SKYPASS } from '@ecp/common/src/const/site/siteNumberConst';

const useLoginForward = (siteNumber, showConfirmDialog, pageId, contentsNo) => {
  const navigate = useNavigate();
  // ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
  const isSkypassMall = useMemo(
    () => siteNumber === SITE_SKYPASS || siteNumber === SITE_KOREANAIR_SAVINGS,
    [siteNumber]
  );
  var host = window.location.host;

  return useCallback(() => {
    var returnUrl = '';
    var redirectUrl = '';
    showConfirmDialog('로그인이 필요한 서비스입니다. \n 로그인 하시겠습니까?', () => {
      if (isSkypassMall) {
        // ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
        if (siteNumber === SITE_SKYPASS || siteNumber === SITE_KOREANAIR_SAVINGS) {
          Netfunnel.NetFunnel_Action({ action_id: 'skypass_login' }, () => {
            Netfunnel.NetFunnel_Complete({}, () => {});
          });
        }
      }
      clearAccessTokens();

      var page_url = '';
      switch (pageId) {
        case PAGE_ID.EVENT:
          page_url = isSkypassMall
            ? `?page_id=${pageId}@AND@eventNo=${contentsNo}`
            : `?page_id=${pageId}&eventNo=${contentsNo}`;
          break;
        case PAGE_ID.GOOD:
          page_url = isSkypassMall
            ? `?page_id=${pageId}@AND@good_no=${contentsNo}`
            : `?page_id=${pageId}&good_no=${contentsNo}`;
          break;
        case PAGE_ID.EXHIBITION:
          page_url = isSkypassMall
            ? `?page_id=${pageId}@AND@disp_ctg_no=${contentsNo}`
            : `?page_id=${pageId}&disp_ctg_no=${contentsNo}`;
          break;
        case PAGE_ID.MQNA:
          page_url = `?page_id=${pageId}`;
          break;
        case PAGE_ID.CQNA:
          page_url = `?page_id=${pageId}`;
          break;
        case PAGE_ID.GIFTSHOW:
          page_url = `?page_id=${pageId}`;
          break;
        case PAGE_ID.ORDER:
          page_url = `?page_id=${pageId}`;
          break;
        case PAGE_ID.CUSTOMER_QNA:
          page_url = `?page_id=${pageId}`;
          break;
        default:
          page_url += ``;
      }

      if (process.env.REACT_APP_ENV === 'local') {
        returnUrl = 'https://oa-local.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';
        redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo')
          ? '?redirectUrl=https://' + host + '/mobile/secure/login/initKOAIRLogin.action'
          : '?redirectUrl=https://' + host + '/secure/login/initKOAIRLogin.action';
        isSkypassMall
          ? (window.location.href =
            'https://www.koreanair.com/gw/ssoLoginWelstory.html?site=welstory&lang=ko&returnUrl=' +
            returnUrl +
            redirectUrl +
            page_url)
          : navigate('/login' + page_url);
      } else if (process.env.REACT_APP_ENV === 'stg' || process.env.REACT_APP_ENV === 'dev') {
        returnUrl = 'https://stgoa.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';
        redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo')
          ? '?redirectUrl=https://' + host + '/mobile/secure/login/initKOAIRLogin.action'
          : '?redirectUrl=https://' + host + '/secure/login/initKOAIRLogin.action';
        isSkypassMall
          ? (window.location.href =
              'https://www.koreanair.com/gw/ssoLoginWelstory.html?site=welstory&lang=ko&returnUrl=' +
              returnUrl +
              redirectUrl +
              page_url)
          : navigate('/login' + page_url);
      } else {
        returnUrl = 'https://ecoa.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';
        redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo')
          ? '?redirectUrl=https://' + host + '/mobile/secure/login/initKOAIRLogin.action'
          : '?redirectUrl=https://' + host + '/secure/login/initKOAIRLogin.action';
        isSkypassMall
          ? (window.location.href =
              'https://www.koreanair.com/gw/ssoLoginWelstory.html?site=welstory&lang=ko&returnUrl=' +
              returnUrl +
              redirectUrl +
              page_url)
          : navigate('/login' + page_url);
      }
    });
  }, []);
};

export const useLogin = (siteNumber) => {
  const navigate = useNavigate();
  // ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
  const isSkypassMall = useMemo(
    () => siteNumber === SITE_SKYPASS || siteNumber === SITE_KOREANAIR_SAVINGS,
    [siteNumber]
  );

  return useCallback(() => {
    var returnUrl = '';
    var redirectUrl = '';
    var host = window.location.host;

    if (isSkypassMall) {
      // ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
      if (siteNumber === SITE_SKYPASS || siteNumber === SITE_KOREANAIR_SAVINGS) {
        Netfunnel.NetFunnel_Action({ action_id: 'skypass_login' }, () => {
          Netfunnel.NetFunnel_Complete({}, () => {});
        });
      }
    }

    clearAccessTokens();

    if (process.env.REACT_APP_ENV === 'local') {
      returnUrl = 'https://oa-local.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';
      redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo')
        ? '?redirectUrl=https://' + host + '/mobile/secure/login/initKOAIRLogin.action'
        : '?redirectUrl=https://' + host + '/secure/login/initKOAIRLogin.action';
      isSkypassMall
        ? (window.location.href =
            'https://www.koreanair.com/gw/ssoLoginWelstory.html?site=welstory&lang=ko&returnUrl=' +
            returnUrl +
            redirectUrl)
        : navigate('/login');
    } else if (process.env.REACT_APP_ENV === 'stg' || process.env.REACT_APP_ENV === 'dev') {
      returnUrl = 'https://stgoa.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';
      redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo')
        ? '?redirectUrl=https://' + host + '/mobile/secure/login/initKOAIRLogin.action'
        : '?redirectUrl=https://' + host + '/secure/login/initKOAIRLogin.action';
      isSkypassMall
        ? (window.location.href =
            'https://www.koreanair.com/gw/ssoLoginWelstory.html?site=welstory&lang=ko&returnUrl=' +
            returnUrl +
            redirectUrl)
        : navigate('/login');
    } else {
      returnUrl = 'https://ecoa.welstorymall.com/secure/login/outsitesso/initKOAIRLogin.action';
      redirectUrl = process.env.REACT_APP_CLOUDFRONT_URL?.substring(8)?.split('.')[0]?.includes('mo')
        ? '?redirectUrl=https://' + host + '/mobile/secure/login/initKOAIRLogin.action'
        : '?redirectUrl=https://' + host + '/secure/login/initKOAIRLogin.action';
      isSkypassMall
        ? (window.location.href =
            'https://www.koreanair.com/gw/ssoLoginWelstory.html?site=welstory&lang=ko&returnUrl=' +
            returnUrl +
            redirectUrl)
        : navigate('/login');
    }
  }, []);
};

export default useLoginForward;
